import { EnrollmentIcon, HeaderTitleBar, HelpFactoryComponent } from '@/components/common';
import { CounterBar, CredentialTab, EnrollmentTab } from '@/components/enrollment';
import { EventTable } from '@/components/event';
import { User } from '@/model/AccountModel';
import { EnrollmentTabKey } from '@/model/EnrollmentModel';
import { HelpFeature } from '@/model/HelpModel';
import { useStoreSelector } from '@/store';
import { selectDisplayAddViaSmartCard, selectFetchingScanData, selectPersonId } from '@/store/enrollment/selectors';
import { Tabs, TabsProps } from 'antd';
import React, { useState } from 'react';
import './enrollment.scss';

let user: User = getUser();
const { showEventsOnEnrollmentPage } = user;
user = null;
const topicId: string = 'EnrollmentTab';

const EnrollmentPage: React.FC = () => {
	//#region state management variables
	const [activeKey, setActiveKey] = useState<EnrollmentTabKey>(EnrollmentTabKey.Enrollment);

	const fetchingScanData: boolean = useStoreSelector<boolean>(selectFetchingScanData);
	const personId: number = useStoreSelector<number>(selectPersonId);
	const displayAddViaSmartCard: boolean = useStoreSelector<boolean>(selectDisplayAddViaSmartCard);
	//#endregion

	const handleOnChangeActiveKey = (key: string) => {
		setActiveKey(Number(key));
	};

	const showCounterBar = activeKey === EnrollmentTabKey.UnassignedAndGuestCredentials || (personId === 0 && !displayAddViaSmartCard);

	const items: TabsProps['items'] = [
		{
			key: EnrollmentTabKey.Enrollment.toString(),
			label: <span data-test-id='credentialEnrollmentTab'>{_('Enrollment')}</span>,
			children: <EnrollmentTab />,
		},
		{
			key: EnrollmentTabKey.UnassignedAndGuestCredentials.toString(),
			label: (
				<span data-leavetab={true} data-test-id='credentialUnassignedAndGuestTab' className='tabTitleContent'>
					{_('UnassignedAndGuestCredentials')}
				</span>
			),
			disabled: fetchingScanData,
			children: <CredentialTab />,
		},
	];

	return (
		<>
			<HeaderTitleBar
				id='enrollmentContainer'
				title={_('Enrollment')}
				icon={<EnrollmentIcon />}
				helpButton={<HelpFactoryComponent helpFeature={HelpFeature.Enrollment} topicId={topicId} className='helpButton' isLight={true} />}
			/>
			<Tabs
				items={items}
				className='enrollmentTab'
				type='card'
				destroyInactiveTabPane={false}
				activeKey={activeKey.toString()}
				onChange={handleOnChangeActiveKey}
			/>
			<CounterBar showCounterBar={showCounterBar} />
			{showEventsOnEnrollmentPage && <EventTable />}
		</>
	);
};

export { EnrollmentPage };
